import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=6ca6bcd7&"
import script from "./Icons.scss?vue&type=script&lang=scss&scoped=true&"
export * from "./Icons.scss?vue&type=script&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports